<template>
  <v-container>
    <v-row justify="end">
        <v-btn class='mb-4' @click='onClick編集(null)'>
          <v-icon>
            mdi-plus
          </v-icon>
        </v-btn>
    </v-row>
    <template v-for='(row,index) in 新着情報rtn' :key='index'>
      <v-card class='mb-2'>
        <v-card-title>
          {{row.日付}} {{row.タイトル}}
        </v-card-title>
        <v-card-subtitle>
          {{row.分類}}
        </v-card-subtitle>
        <v-card-text>
          <v-row>
          {{row.内容}}
          </v-row>
        </v-card-text>
        <v-card-actions>
          <template v-if='row.表示'>
            【表示中】
          </template>
          <v-spacer></v-spacer>
          <v-btn @click='onClick編集(row)'><v-icon>mdi-lead-pencil</v-icon>編集</v-btn>
          <v-btn @click='onClick削除(row)'><v-icon>mdi-trash-can</v-icon>削除</v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-container>
  <v-dialog v-model="dialog" scrollable>
    <v-container>
      <v-card>
        <v-card-title>
          編集
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 400px;" class='overflow-auto'>
          <v-row>
            <v-col cols="12" md="3">
              <v-text-field type=date v-model='selectedRow.日付' label='日付'></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field v-model='selectedRow.タイトル' label='タイトル'></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field v-model='selectedRow.分類' label='分類'></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-checkbox v-model='selectedRow.表示' label='表示'></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-textarea v-model='selectedRow.内容' label='内容'></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn @click='dialog=false' class='ml-5'><v-icon>mdi-arrow-left</v-icon>戻る</v-btn>
          <v-spacer></v-spacer>
          <v-btn @click='onClick保存()'><v-icon>mdi-content-save</v-icon>保存</v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </v-dialog>
</template>

<script>
  export default {
    data(){
      return {
        新着情報rtn:[],
        dialog:false,
        selectedRow:{},
      }
    },
    created(){

    },
    mounted(){
      this.新着取得();
    },
    methods:{
      新着取得(){
        this.$emit('overlay');

        let url = '../api/api.php';
        let data = {
          func:"新着取得",
          pageSize:99999,
          表示:"edit",
        };

        let param = {
            method : "POST",
            headers : { "Content-Type": "application/json" },
            body : JSON.stringify(data),
            }
        fetch(url,param)
        .then(response => {return response.text();})
        .then(result => {
          try {
            const jsonData = JSON.parse(result);
            return jsonData;
          }catch(e){
            return Promise.reject({body:result,type:'unparsable'})
          }
        })
        .then(result => {
          this.新着情報rtn = result.新着情報rtn;
          this.$emit('overlay');
        })
        .catch(error =>{
          console.log(error)
          alert('取得できませんでした。\n\n'+error.body);
          this.$emit('overlay');
        })
      },

      onClick編集(row){
        if(row){
          this.selectedRow = row;
        }else{
          this.selectedRow = {}
          let dt = new Date();
          this.selectedRow.日付 = dt.getFullYear() + "-" + ("00"+(dt.getMonth()+1)).slice(-2) + "-" + ("00"+(dt.getDate())).slice(-2)
        }
        this.dialog = true;
      },

      onClick保存(){
        this.$emit('overlay');

        let url = '../api/api.php';
        let data = {
          func:"新着保存",
          selectedRow:this.selectedRow,
        };

        let param = {
            method : "POST",
            headers : { "Content-Type": "application/json" },
            body : JSON.stringify(data),
            }
        fetch(url,param)
        .then(response => {return response.text();})
        .then(result => {
          try {
            const jsonData = JSON.parse(result);
            return jsonData;
          }catch(e){
            return Promise.reject({body:result,type:'unparsable'})
          }
        })
        .then(result => {
          console.log(result);
          this.dialog = false;
          this.新着取得();
          this.$emit('overlay');
        })
        .catch(error =>{
          console.log(error)
          alert('保存できませんでした。\n\n'+error.body);
          this.$emit('overlay');
        })
      },

      onClick削除(row){
        if(window.confirm('削除します')){
          this.do削除(row);
        }
      },

      do削除(row){
        this.$emit('overlay');

        let url = '../api/api.php';
        let data = {
          func:"新着削除",
          selectedRow:row,
        };

        let param = {
            method : "POST",
            headers : { "Content-Type": "application/json" },
            body : JSON.stringify(data),
            }
        fetch(url,param)
        .then(response => {return response.text();})
        .then(result => {
          try {
            const jsonData = JSON.parse(result);
            return jsonData;
          }catch(e){
            return Promise.reject({body:result,type:'unparsable'})
          }
        })
        .then(result => {
          console.log(result)
          this.$emit('overlay');
          this.新着取得();
        })
        .catch(error =>{
          console.log(error)
          alert('削除できませんでした。\n\n'+error.body);
          this.$emit('overlay');
        })
      },
    },

  }
</script>